import { isPlatform } from '@ionic/react';

function isIosApp() {
  return isPlatform('ios') && !isPlatform('mobileweb');
}

export function planManagementEnabled() {
  return !isIosApp();
}
